import { useSimulation } from "../simulation/SimulationProvider";
import type { SimulationState } from "../simulation/state";

const speeds: readonly SimulationState["speed"][] = [0.25, 0.5, 1, 2, 4, 8];

export function PlaybackControls() {
  const { snapshot, state, selectPhase, setSpeed, togglePlayback } =
    useSimulation();

  const selectAdjacentPhase = (direction: "forward" | "backward") => {
    const offset = direction === "forward" ? 1 : -1;
    const phaseIndex = (snapshot.phaseIndex + offset + 8) % 8;
    selectPhase(phaseIndex, direction);
  };

  return (
    <fieldset className="control-group playback-controls">
      <legend>Playback</legend>
      <div className="button-row">
        <button
          type="button"
          aria-pressed={state.isPlaying}
          onClick={togglePlayback}
        >
          {state.isPlaying ? "Pause lunar cycle" : "Play lunar cycle"}
        </button>
        <button
          type="button"
          aria-label="Previous phase"
          onClick={() => selectAdjacentPhase("backward")}
        >
          Previous
        </button>
        <button
          type="button"
          aria-label="Next phase"
          onClick={() => selectAdjacentPhase("forward")}
        >
          Next
        </button>
      </div>
      <label className="select-control" htmlFor="simulation-speed">
        Simulation speed
        <select
          id="simulation-speed"
          value={state.speed}
          onChange={(event) =>
            setSpeed(
              Number(event.currentTarget.value) as SimulationState["speed"],
            )
          }
        >
          {speeds.map((speed) => (
            <option key={speed} value={speed}>
              {speed}×
            </option>
          ))}
        </select>
      </label>
    </fieldset>
  );
}
